import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../AppContext/AppContext';
import UserTools from '../UserTools/UserTools';
import ClonewebxLogo from './ClonewebxLogo';
import './Header.scss';

const placeholderTexts = [
  'Real estate website, luxury style',
  'Travel website with booking features',
  'Wind turbine website',
  'E-commerce fashion store',
  'Restaurant website with menu',
  'Portfolio website for interior designers',
  'Fitness gym landing page',
  'Tech startup SaaS platform',
];

function Header(props: any) {
  const { state } = useContext(AppContext);
  const { user } = state;

  useEffect(() => {
    document.body.classList.add("body-dashboard");
    
    return () => {
       document.body.classList.remove("body-dashboard");
    }
  }, [])

  const homeTo = user && user?.status == 'active' ? '/projects/' : '/verify/';

  return (
    <header className="header">
      <div className="header__inner">
        <Link to={homeTo} className="header__brand" aria-label="ClonewebX home">
          <span className="header__brand-logo">
            <ClonewebxLogo className="header__brand-svg" />
          </span>
          <span className="header__brand-name">ClonewebX</span>
        </Link>
        {user && <UserTools />}
      </div>
    </header>
  );
}

export { placeholderTexts, Header };
export default Header;
